import { useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { IconButton, SvgIcon, Box } from "@mui/material";

import { ReactComponent as CloseIcon } from "../../../../assets/close.svg";

import { useStyles } from "./index.styles";

interface SliderProps {
  images: string[];
  setImageSlider: (flag: boolean) => void;
}

const Slider = ({ images, setImageSlider }: SliderProps) => {
  const [counter, setCounter] = useState(0);
  const classes = useStyles();

  const nextSlide = () => {
    if (counter < images.length - 1) {
      setCounter(counter + 1);
    }
  };

  const prevSlide = () => {
    if (counter > 0) {
      setCounter(counter - 1);
    }
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.wrapper}>
        <SvgIcon
          component={CloseIcon}
          onClick={() => setImageSlider(false)}
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "16px",
            cursor: "pointer",
          }}
          inheritViewBox
        />
        <IconButton onClick={prevSlide}>
          <FaArrowLeft />
        </IconButton>
        <Box className={classes.imgContainer}>
          <Box
            className={classes.imgCarousel}
            sx={{ transform: `translateX(-${counter * 100}%)` }}
          >
            {images.map((src: any, index: any) => (
              <img
                key={`${src}-${index}`}
                src={src}
                alt=""
                style={{ left: `${index * 100}%` }}
              />
            ))}
          </Box>
        </Box>
        <IconButton onClick={nextSlide}>
          <FaArrowRight />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Slider;
